module.exports = __webpack_public_path__ + "img/kutatasi partner_gomb.d1c91a5e.png";